import {
  normalizeScreeningColorProfile,
  type ScreeningColorProfile,
} from '@/theme/colorProfiles'

type RawColorProfile = {
  identifier?: string | null
  template?: {
    key?: string | null
  } | null
}

type RawSiteApiOutput = {
  form_select?: {
    key?: string | null
    datacolor?: string | null
  } | null
  color_profile?: RawColorProfile | null
  site_group?: {
    id?: number | string | null
    key?: string | null
    name?: string | null
    slug?: string | null
  } | null
}

export type RawSiteSettings = {
  options?: {
    site_api_output?: RawSiteApiOutput | null
    color_profile?: RawColorProfile | null
  } | null
}

export type SiteSettings = {
  colorProfile: ScreeningColorProfile | null
  currentTestKey: string | null
  currentCategory: {
    id: number | null
    key: string | null
    name: string | null
    slug: string | null
  } | null
}

function cleanString(value: unknown) {
  return typeof value === 'string' ? value.trim() : ''
}

export function mapSiteSettings(input: RawSiteSettings): SiteSettings {
  const siteApiOutput = input.options?.site_api_output
  const colorProfile = siteApiOutput?.color_profile ?? input.options?.color_profile
  const rawCategory = siteApiOutput?.site_group
  const categoryId = Number(rawCategory?.id ?? 0)
  const currentCategory = rawCategory
    ? {
        id: Number.isInteger(categoryId) && categoryId > 0 ? categoryId : null,
        key: cleanString(rawCategory.key) || null,
        name: cleanString(rawCategory.name) || null,
        slug: cleanString(rawCategory.slug) || null,
      }
    : null

  return {
    colorProfile: normalizeScreeningColorProfile(
      cleanString(colorProfile?.identifier) ||
      cleanString(colorProfile?.template?.key) ||
      cleanString(siteApiOutput?.form_select?.datacolor),
    ),
    currentTestKey: cleanString(siteApiOutput?.form_select?.key) || null,
    currentCategory,
  }
}
